import ClientMergeContainer from "@legacy/clients/ClientMergeContainer"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"
import useToastQueue from "@hooks/useToastQueue"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

import { CLIENTS_ROUTES } from "@routes/clients"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

export default function ClientMerge() {
    const clientId = window.CLIENT_ID

    const [detailsRoute] = useSlugExtractor([CLIENTS_ROUTES.DETAILS], clientId)
    const { addToastToQueue } = useToastQueue()
    const { hasPermission } = useHasAccess()

    const detailsBackDestination = hasPermission("clients_view_permission", PERMISSION_LEVEL.FULL)
        ? detailsRoute
        : undefined

    return (
        <AppFrame.Root pageId="ClientMerge" navigationType="inner">
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageInnerTitle label="Merge Client" backDestination={detailsBackDestination} />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <ClientMergeContainer formMode="MERGE_CLIENT" addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
